__webpack_require__.p = "/demo/mindsumo/";